import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-slate-50 text-slate-800">
    <header className="bg-white border-b border-slate-200 py-4">
      <div className="max-w-4xl mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="font-bold text-lg font-['Manrope']">
          <span className="text-emerald-600">Capsule</span> Patrimoine
        </Link>
        <Link
          to="/"
          className="text-sm text-slate-600 hover:text-emerald-700 inline-flex items-center gap-1"
          data-testid="back-home-link"
        >
          <ArrowLeft className="h-4 w-4" /> Accueil
        </Link>
      </div>
    </header>
    <main className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl sm:text-4xl font-bold font-['Manrope'] mb-8 text-slate-900">{title}</h1>
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10 prose prose-slate max-w-none prose-headings:font-['Manrope'] prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-p:leading-relaxed prose-a:text-emerald-700">
        {children}
      </div>
      <div className="mt-6 text-xs text-slate-500 text-center">
        Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
      </div>
    </main>
  </div>
);

const MentionsLegalesPage = () => (
  <LegalLayout title="Mentions légales">
    <h2>1. Éditeur du site</h2>
    <p>
      Le site <strong>capsulepatrimoine.com</strong> et l&apos;application <strong>app.capsulepatrimoine.com</strong> (ci-après « le Service ») sont édités par :
    </p>
    <ul>
      <li><strong>Raison sociale :</strong> Capsule Patrimoine</li>
      <li><strong>Représentante légale / Directrice de la publication :</strong> Valérie Girin</li>
      <li><strong>Forme juridique :</strong> Entreprise individuelle (auto-entrepreneur)</li>
      <li><strong>Adresse du siège social :</strong> 13 Impasse des Jonquilles, 42120 Commelle-Vernay, France</li>
      <li><strong>SIRET :</strong> 484 280 771 00060</li>
      <li><strong>SIREN :</strong> 484 280 771</li>
      <li><strong>Code APE / NAF :</strong> 7022Z (Conseil pour les affaires et autres conseils de gestion)</li>
      <li><strong>Numéro TVA intracommunautaire :</strong> TVA non applicable, art. 293 B du CGI (franchise en base)</li>
      <li><strong>Adresse email :</strong> <a href="mailto:contact@capsulepatrimoine.com">contact@capsulepatrimoine.com</a></li>
      <li><strong>Téléphone :</strong> 07 44 43 70 94</li>
    </ul>

    <h2>2. Hébergement</h2>
    <p>
      Le Service est hébergé par <strong>Emergent Labs Inc.</strong> (États-Unis), plateforme de développement et d&apos;hébergement d&apos;applications web, sur une infrastructure cloud managée et sécurisée (chiffrement des données au repos, HTTPS/TLS). La diffusion est assurée via le réseau <strong>Cloudflare</strong>. Le nom de domaine est enregistré auprès de <strong>IONOS SE</strong> (7 place de la Gare, 57200 Sarreguemines, France).
    </p>
    <p>
      Les données personnelles sont traitées conformément au RGPD ; les garanties applicables aux éventuels transferts hors Union européenne sont détaillées dans notre <Link to="/politique-de-confidentialite">Politique de confidentialité</Link>.
    </p>

    <h2>3. Propriété intellectuelle</h2>
    <p>
      L&apos;ensemble du contenu du Service (textes, graphismes, logo, icônes, images, vidéos, sons, ainsi que leur mise en forme) est la propriété exclusive de l&apos;éditeur, à l&apos;exception des marques, logos ou contenus appartenant à d&apos;autres sociétés partenaires ou auteurs.
    </p>
    <p>
      Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces différents éléments est strictement interdite sans l&apos;accord exprès par écrit de l&apos;éditeur.
    </p>

    <h2>4. Responsabilité</h2>
    <p>
      Les informations fournies sur le Service (calculs URSSAF, TVA, cotisations sociales, conseils patrimoniaux) sont indicatives et ne se substituent pas à un conseil personnalisé délivré par un professionnel du chiffre (expert-comptable) ou du droit. L&apos;éditeur décline toute responsabilité quant aux conséquences d&apos;une utilisation de ces informations sans validation professionnelle.
    </p>
    <p>
      Les calculs sont basés sur la réglementation française en vigueur à la date de mise à jour indiquée. L&apos;éditeur s&apos;efforce de maintenir ces informations à jour mais ne peut garantir l&apos;exactitude en cas de changement législatif récent.
    </p>

    <h2>5. Droit applicable</h2>
    <p>
      Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
    </p>
  </LegalLayout>
);

export default MentionsLegalesPage;
